"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section ref={heroRef} className="relative bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className={`space-y-6 ${heroVisible ? "animate-fade-in-up" : "opacity-0"}`}>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              Build Your Restaurant's Email List
            </h1>
            <p className="text-lg sm:text-xl text-muted-foreground max-w-xl">
              Click Viral helps restaurants accelerate subscriber growth with data-driven strategies, compelling copy, and seamless POS integration—turning diners into loyal patrons.
            </p>
          </div>

          {}
          <div className={`relative ${heroVisible ? "animate-fade-in-up-delay-100" : "opacity-0"}`}>
            <div className="relative overflow-hidden rounded-lg shadow-strong group">
              <img src="https://click-viral.com/wp-content/uploads/2026/01/chris-liverani-oCsaxvGCehM-unsplash-scaled.jpg" alt="Bustling restaurant kitchen with chefs preparing dishes" className="w-full h-auto object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-out-back)] group-hover:scale-[1.005]" />
            </div>
            <div className="mt-8 flex justify-center lg:justify-start">
              <Button asChild size="lg" className="btn-primary shadow-medium">
                <Link to="#contact" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground shadow-xs h-10 rounded-md px-6 has-[>svg]:px-4 btn-primary shadow-medium !bg-[hsl(213,94%,68%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">Schedule a Demo</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}